import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getOtherOptionsFromWindow, isCrawler } from "../../../utils";
import { getUserDecision } from "../../getUserDecision";
/**
 * When the server decides to not predecision anything e. g. due to
 * legal settings (privacy policy, imprint, hide on additional pages) or
 * the login page.
 */

var preDecisionGatewayIsPreventPreDecision = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var other, userDecision;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            other = getOtherOptionsFromWindow();
            userDecision = getUserDecision();
            return _context.abrupt("return", other.isPreventPreDecision && userDecision === false ? isCrawler() ? // For crawlers we need to explictely allow cookies on all pages
            "all" : "nothing" : false);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayIsPreventPreDecision() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayIsPreventPreDecision };